import React, {
	ReactElement,
	useRef,
	ReactNode,
	useState,
	RefObject,
} from 'react';

export interface DropdownProps {
	trigger: ReactElement;
	children: ReactElement | ReactNode;
	className?: string;
	triggerClassName?: string;
	isRightAligned?: boolean;
	triggerRef?: RefObject<HTMLDivElement>;
	isDropup?: boolean;
	displayChangedCallback?: (pDisplay: boolean) => void;
}

export default function Dropdown({
	trigger,
	children,
	className,
	triggerClassName,
	triggerRef,
	isRightAligned,
	isDropup,
	displayChangedCallback,
}: DropdownProps) {
	const [lDisplay, lSetDisplay] = useState(false);
	const lContentRef = useRef<HTMLDivElement>(null);

	const handleClickOutside = (event: PointerEvent) => {
		if (
			event.target instanceof Node &&
			!lContentRef.current?.contains(event.target)
		) {
			lSetDisplay(false);
			document.removeEventListener('pointerdown', handleClickOutside);
			if (displayChangedCallback) displayChangedCallback(false);
		}
	};

	const toggleDropdown = () => {
		// Toggle display and set up/removal of event listeners
		if (!lDisplay) {
			document.addEventListener('pointerdown', handleClickOutside);
		} else {
			document.removeEventListener('pointerdown', handleClickOutside);
		}
		if (displayChangedCallback) displayChangedCallback(!lDisplay);
		lSetDisplay(!lDisplay);
	};

	return (
		<div className={'Dropdown ' + className}>
			<div
				className={'dropdown-trigger' + (triggerClassName ? triggerClassName : '')}
				ref={triggerRef}
				onPointerDown={e => {
					// Prevent double-toggling on touchscreens by handling pointerdown
					e.stopPropagation();
					toggleDropdown();
				}}
			>
				{trigger}
			</div>
			{lDisplay && (
				<div
					ref={lContentRef}
					className={`dropdown-content ${
						isRightAligned ? 'dropdown-right' : 'dropdown-left'
					} ${isDropup ? 'dropup' : 'dropdown'}`}
				>
					{children}
				</div>
			)}
		</div>
	);
}
